export const CommonModules = {
    ASSOCIATE_DASHBOARD: 'ASSOCIATE_DASHBOARD'
};